import React, { forwardRef, ReactNode } from 'react';
import * as S from './DesktopFilterAccordion.styles';
import { Accordion, AccordionRef } from '@/components/UI/Accordion/Accordion';

interface Props {
  title: string;
  value?: string | null;
  search?: ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
  onClear: () => void;
}

export const DesktopFilterAccordion = forwardRef<AccordionRef, Props>(
  ({ title, value, search, defaultOpen, children, onClear }, ref) => {
    function handleClear(event: React.MouseEvent) {
      event.stopPropagation();
      onClear();
    }

    return (
      <Accordion
        ref={ref}
        title={title}
        contentHead={search}
        subTitle={
          value && (
            <S.SubtitleContainer>
              {value} <S.ClearButton onClick={handleClear} />
            </S.SubtitleContainer>
          )
        }
        maxHeight={330}
        defaultOpen={defaultOpen}
      >
        {children}
      </Accordion>
    );
  }
);

DesktopFilterAccordion.displayName = 'DesktopFilterAccordion';
